import { Pipe, PipeTransform, Injectable, inject } from "@angular/core";
import { ILgFormatter, ILgFormatterOptions, MoneyFormatterFactory } from "@logex/framework/core";
import { Nullable } from "@logex/framework/types";

export type IFmtMoneyOptions = Partial<
    Pick<ILgFormatterOptions, "decimals" | "forceSign" | "zeroDash">
>;

const defaultOptions: ILgFormatterOptions = {};

@Injectable({ providedIn: "root" })
@Pipe({
    standalone: true,
    name: "fmtMoney",
    pure: true
})
export class LgFormatMoneyPipe implements PipeTransform {
    private _formatter: ILgFormatter<number> = inject(MoneyFormatterFactory).create(defaultOptions);

    public transform(input: Nullable<string | number>, options?: IFmtMoneyOptions): string;

    /**
     * @deprecated Use options variant instead
     */
    public transform(
        value: Nullable<string | number>,
        decimals?: number,
        zeroDash?: boolean,
        forceSign?: boolean
    ): string;

    public transform(
        value: Nullable<string | number>,
        options?: number | IFmtMoneyOptions,
        zeroDash?: boolean,
        forceSign?: boolean
    ): string {
        const parameterOptions = this._getParameterOptions(options, zeroDash, forceSign);

        if (typeof value === "string") {
            value = +value;
        }
        return this._formatter.format(value, parameterOptions);
    }

    private _getParameterOptions(
        options?: number | IFmtMoneyOptions,
        zeroDash?: boolean,
        forceSign?: boolean
    ): ILgFormatterOptions {
        let parameterOptions: ILgFormatterOptions;
        if (typeof options === "number") {
            parameterOptions = { decimals: options };
        } else {
            parameterOptions = { ...options };
        }

        if (zeroDash !== undefined) {
            parameterOptions.zeroDash = zeroDash;
        }
        if (forceSign !== undefined) {
            parameterOptions.forceSign = forceSign;
        }

        return parameterOptions;
    }
}
